import React from 'react';
import { ROAD_TRIPS } from '../data/sectionsData';

export default function RidesSection() {
    return (
        <section className="moto-glow bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] py-16 md:py-24 px-4 md:px-6 relative overflow-hidden" id="rides">
            <div className="max-w-[1200px] mx-auto relative z-10">
                <div className="mb-16 reveal">
                    <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#e94560]/15 text-[#e94560] rounded-full text-[0.8125rem] font-semibold uppercase tracking-widest mb-4">
                        <i className="fa-solid fa-motorcycle"></i> Rides
                    </span>
                    <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-bold tracking-tight text-[#f5f5f5] mb-2">Life on Two Wheels</h2>
                    <p className="text-[1.0625rem] text-[#f5f5f5]/60 max-w-[560px] leading-relaxed">
                        Bikes are more than just vehicles, they're tickets to freedom.
                    </p>
                </div>

                {/* Bike showcase */}
                <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-white/[0.04] rounded-[28px] p-6 md:p-8 border border-white/[0.06] mb-16 reveal">
                    <div className="w-full md:w-[320px] h-[200px] md:h-[220px] rounded-2xl overflow-hidden shrink-0 bg-white/5">
                        <img
                            src="https://bysbvuow8qmgi9ew.public.blob.vercel-storage.com/hness/hness.webp"
                            alt="Honda CB350 Highness"
                            className="w-full h-full object-cover"
                            loading="lazy"
                        />
                    </div>
                    <div className="text-center md:text-left">
                        <h3 className="text-[1.75rem] font-bold text-[#f5f5f5] mb-2">Honda CB350 Highness</h3>
                        <p className="text-[#f5f5f5]/60 leading-relaxed mb-4">
                            A modern classic that blends retro aesthetics with Honda's legendary reliability.
                            The perfect companion for both city streets and open highways.
                        </p>
                        <div className="flex gap-6 justify-center md:justify-start">
                            {[
                                { value: '348', label: 'CC' },
                                { value: '21', label: 'BHP' },
                                { value: '8K+', label: 'KM RIDDEN' },
                            ].map((spec) => (
                                <div key={spec.label} className="text-center p-4 bg-white/5 rounded-xl min-w-[90px]">
                                    <span className="block text-2xl font-bold text-[#e94560]">{spec.value}</span>
                                    <span className="text-xs text-[#f5f5f5]/50 uppercase tracking-wide">{spec.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Road trips */}
                <div className="reveal">
                    <h3 className="text-xl font-semibold text-[#f5f5f5] mb-6 flex items-center gap-2">
                        <i className="fa-solid fa-route"></i> Road Trips
                    </h3>
                    <div className="trips-scroll flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory">
                        {ROAD_TRIPS.map((trip, i) => (
                            <div key={i} className="group min-w-[260px] xs:min-w-[300px] bg-white/[0.06] rounded-2xl overflow-hidden snap-start shrink-0 border border-white/[0.06] hover:bg-white/10 hover:-translate-y-1 hover:border-[#e94560]/30 transition-all duration-400 ease-emphasized">
                                <div className="w-full h-[180px] bg-white/[0.04] overflow-hidden">
                                    <img
                                        src={trip.imageLink}
                                        alt={trip.title}
                                        className="w-full h-full object-cover group-hover:scale-[1.08] transition-transform duration-600 ease-standard"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="px-6 py-4 flex items-center justify-between">
                                    <div>
                                        <h4 className="text-[1.0625rem] font-semibold text-[#f5f5f5] mb-1">{trip.title}</h4>
                                        <p className="text-[0.8125rem] text-[#f5f5f5]/50 flex items-center gap-1.5">
                                            <i className="fa-solid fa-road"></i> {trip.detail}
                                        </p>
                                    </div>
                                    <a
                                        href={trip.locationLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-9 h-9 rounded-full bg-white/[0.08] flex items-center justify-center text-[#f5f5f5]/60 hover:bg-[#e94560]/20 hover:text-[#e94560] transition-all duration-200 shrink-0"
                                        title="View on Maps"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <i className="fa-solid fa-location-dot text-sm"></i>
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
